import { createSelector } from 'reselect';

export const getMiscCosts = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.anticipatedCostReport.data.miscCosts,
  (miscCosts) => {
    return miscCosts;
  }
);

export const getEdit = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.anticipatedCostReport.ui.edit,
  (edit) => {
    return edit;
  }
);

export const getSaving = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.anticipatedCostReport.ui.saving,
  (saving) => {
    return saving;
  }
);

export const getProposal = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.anticipatedCostReport.data.proposal,
  (proposal) => {
    return proposal;
  }
);

export const getAdditionalCostEdit = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.anticipatedCostReport.ui
      .additionalCostEdit,
  (additionalCostEdit) => {
    return additionalCostEdit;
  }
);

export const getAdditionalCostSaving = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.anticipatedCostReport.ui
      .additionalCostSaving,
  (additionalCostSaving) => {
    return additionalCostSaving;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/anticipated-cost-report/store/selectors.js